import React from "react";

export const TermsOfService = ({ setCurrentView }) => {
 return (
 <div className="space-y-6">
 <div className="bg-white p-6 rounded-lg shadow-md">
 {/* Кнопка "Назад к регистрации" */}
 {setCurrentView && (
 <div className="mb-4">
 <button
 onClick={() =>setCurrentView("home")}
 className="flex items-center text-blue-600 hover:text-blue-800 text-sm"
 >
 ← Назад к регистрации
 </button>
 </div>
 )}
 
 <div className="text-center mb-6">
 <h2 className="text-2xl font-bold text-gray-900 mb-2">Публичная оферта</h2>
 <p className="text-sm text-gray-500">reversia.ru | Редакция от 4 августа 2026 года</p>
 </div>
 
 <div className="prose max-w-none text-gray-700 space-y-6">
 
 {/* Языковая оговорка */}
 <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400">
 <h3 className="text-lg font-semibold text-gray-800 mb-3">Языковая оговорка</h3>
 <ol className="list-decimal list-inside space-y-2 text-sm">
 <li>Русскоязычная версия Оферты является единственно юридически обязательной. Переводы на другие языки предоставляются исключительно для ознакомления и не могут служить основанием для споров.</li>
 <li>Все уведомления, налоговые документы и официальные обращения Администрации составляются на русском языке.</li>
 <li>В случае противоречий между переводами и оригиналом применяется русскоязычная версия (ст. 431 ГК РФ).</li>
 </ol>
 </div>

 {/* Преамбула */}
 <div>
 <p className="leading-relaxed">Сумченко О.А. 
 (ИНН 230808284051) (далее – «Администрация»), 
 размещает настоящую публичную оферту в соответствии со ст. 435 и 437 Гражданского Кодекса 
 Российской Федерации с предложением физическим и юридическим лицам заключить Договор на 
 нижеследующих условиях.
 </p>
 <p className="mt-3 text-sm bg-gray-50 p-3 rounded">
   Сервис «Реверсия» действует как <strong>агент-посредник</strong> в соответствии со ст. 1005 ГК РФ, 
   обеспечивая организационное взаимодействие между Заказчиками (Пользователями) и Исполнителями. 
   Администрация выступает агентом, получающим агентское вознаграждение в размере Комиссии Платформы. 
   Средства, поступающие на счёт Администрации сверх Комиссии Платформы, являются транзитными 
   и предназначены для выплаты Исполнителю по итогам выполненного задания. 
   Администрация не является стороной в договорах на оказание услуг между Заказчиками и Исполнителями.
 </p>
 </div>

 {/* 1. Термины */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">1. Термины</h3>
 <div className="space-y-3">
 <div>
 <strong>1.1.1. Акцепт публичной оферты</strong> – полное и безоговорочное принятие Пользователем условий настоящей публичной Оферты.
 </div>
 <div>
 <strong>1.1.2. Договор</strong> – возмездное соглашение между Администрацией и Пользователем, заключенное посредством Акцепта публичной Оферты.
 </div>
 <div>
 <strong>1.1.3. Пользователь</strong> – физическое лицо, заключившее с Администрацией Договор на условиях, содержащихся в настоящей публичной Оферте.
 </div>
 <div>
 <strong>1.1.4. «Сервис»</strong> – цифровая платформа «Реверсия» для заказа фото-/видеосъемки, доступная через веб-сайт reversia.ru и мобильное веб-приложение.
 </div>
 <div>
 <strong>1.1.5. «Администрация»</strong> – Сумченко О.А., ИНН 230808284051, владелец и оператор платформы «Реверсия».
 </div>
 <div>
 <strong>1.1.6. «Исполнитель»</strong> – физическое лицо, зарегистрированное в Сервисе для оказания услуг по заказам Пользователей.
 </div>
 <div className="bg-yellow-50 p-3 rounded">
 <strong>1.1.7. «Комиссия Платформы»</strong> – от 10%, включая:
 <ul className="list-disc list-inside ml-4 mt-2">
 <li>Базовый тариф: 10%;</li>
 <li>Спецусловия (акции, рефералы): от 5% до 10%.</li>
 </ul>
 </div>
 <div>
 <strong>1.1.8. «Уход за захоронениями»</strong> – комплекс услуг по благоустройству, очистке и фотодокументированию мест погребения, оказываемый Исполнителем по запросу Пользователя.
 </div>
 <div>
 <strong>1.1.9. «Тайный покупатель»</strong> – анонимная услуга проверки качества услуг/товаров третьих лиц с обязательным предоставлением отчетной документации.
 </div>
 <div className="bg-green-50 p-3 rounded">
 <strong>1.1.10. «Мобильный корреспондент»</strong> – исполнитель, оказывающий услуги оперативной фото-/видеосъемки для СМИ и других заказчиков, прошедший расширенную верификацию (портфолио, контакты редакции). <span className="font-semibold text-green-700">Комиссия платформы: 15-25%.</span>
 </div>
 <div className="bg-blue-50 p-3 rounded border-l-4 border-blue-400">
 <strong>1.1.11. «Верификация личности»</strong> – добровольная процедура подтверждения личности Исполнителя по документу, удостоверяющему личность (паспорт). Проверка данных проводится вручную Администрацией Сервиса, без применения автоматизированных систем распознавания и без передачи данных третьим лицам. Для заданий, связанных с доступом к жилым помещениям, дачным участкам, личным вещам и документам Пользователя, а также для услуг ухода за захоронениями, откликаться могут <strong>только Исполнители, прошедшие верификацию личности</strong>. Порядок обработки и сроки хранения данных верификации определены Политикой конфиденциальности (п. 3.1).
 </div>
 </div>
 </div>

 {/* 2. Акцепт оферты */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">2. Акцепт оферты</h3>
 <div className="space-y-4">
 <div>
 <h4 className="font-semibold mb-2">2.1. Акцепт условий:</h4>
 <div className="grid md:grid-cols-2 gap-4">
 <div className="bg-blue-50 p-4 rounded">
 <strong>Для Пользователей (клиентов):</strong>
 <ul className="list-disc list-inside mt-2 text-sm">
 <li>Регистрация в приложении</li>
 <li>Оплата заказа</li>
 <li>Использование функций Сервиса</li>
 </ul>
 </div>
 <div className="bg-green-50 p-4 rounded">
 <strong>Для Исполнителей:</strong>
 <ul className="list-disc list-inside mt-2 text-sm">
 <li>Прохождение верификации</li>
 <li>Принятие отдельного «Соглашения с Исполнителем»</li>
 <li>Активация профиля</li>
 </ul>
 </div>
 </div>
 </div>
 
 <div className="bg-gray-50 p-4 rounded">
 <p><strong>2.8. Оплата услуг</strong> производится через платёжный сервис ЮKassa, который:</p>
 <ul className="list-disc list-inside mt-2 text-sm">
 <li>Обеспечивает безопасную обработку платежей</li>
 <li>Направляет Пользователю подтверждение оплаты на email/SMS</li>
 <li>Не требует раскрытия банковских реквизитов Исполнителя</li>
 </ul>
 <p className="text-xs text-gray-600 mt-2">
 <strong>Важно:</strong> Распределение средств и выплата Исполнителю происходят в течение 1–3 рабочих дней
 после подтверждения выполнения задания. Каждая сторона самостоятельно обеспечивает налоговую отчётность
 в соответствии с применяемым налоговым режимом.
 </p>
 </div>
 
 <div className="mt-3 bg-yellow-50 p-4 rounded border-l-4 border-yellow-400">
 <p className="font-semibold mb-2">2.8.1. Обязанности по налоговой отчетности:</p>
 <div className="space-y-2 text-sm">
 <div>
 <strong>Исполнитель обязуется:</strong>
 <ul className="list-disc list-inside mt-1 ml-4">
 <li>Предоставить Администрации разрешение на формирование фискальных чеков через YuKassa</li>
 <li>Указать корректные паспортные данные и ИНН для автоматического формирования чеков</li>
 <li>Предоставить все необходимые документы для налогового учета</li>
 <li>Самостоятельно уплачивать налоги согласно применяемому налоговому режиму</li>
 <li>Уведомлять о смене налогового статуса в течение 3 рабочих дней</li>
 </ul>
 </div>
 <div>
 <strong>Администрация обязуется:</strong>
 <ul className="list-disc list-inside mt-1 ml-4">
 <li>Выставлять отдельный чек за комиссионные услуги платформы</li>
 <li>Уплачивать налоги с полученных комиссий в соответствии с законодательством РФ</li>
 </ul>
 </div>
 </div>
 </div>
 </div>
 </div>

 {/* 3. Финансовые условия */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">3. Финансовые условия</h3>
 
 {/* Таблица структуры платежей */}
 <div className="overflow-x-auto mb-4">
 <table className="min-w-full bg-white border border-gray-200 rounded-lg">
 <thead className="bg-gray-50">
 <tr>
 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Тип платежа</th>
 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Стандартный размер</th>
 <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Особые условия</th>
 </tr>
 </thead>
 <tbody className="divide-y divide-gray-200 text-sm">
 <tr>
 <td className="px-4 py-3 font-medium">Общая сумма заказа</td>
 <td className="px-4 py-3">100%</td>
 <td className="px-4 py-3">-</td>
 </tr>
 <tr className="bg-yellow-50">
 <td className="px-4 py-3 font-medium">Комиссия платформы</td>
 <td className="px-4 py-3 font-semibold text-yellow-700">10%</td>
 <td className="px-4 py-3">Снижена до 5-10% для акций/партнеров</td>
 </tr>
 <tr>
 <td className="px-4 py-3 font-medium">Вознаграждение исполнителя</td>
 <td className="px-4 py-3 font-semibold text-green-700">90%</td>
 <td className="px-4 py-3">-</td>
 </tr>
 <tr className="bg-red-50">
 <td className="px-4 py-3 font-medium">Спецуслуги</td>
 <td className="px-4 py-3 font-semibold text-red-700">15-25%</td>
 <td className="px-4 py-3">Тайный покупатель, Уход за захоронениями, Мобильный корреспондент</td>
 </tr>
 </tbody>
 </table>
 </div>

 <div className="bg-blue-50 p-4 rounded">
 <p className="font-semibold mb-2">3.2. Процесс оплаты:</p>
 <ul className="list-disc list-inside space-y-1 text-sm">
 <li>Клиент оплачивает 100% стоимости через Сервис</li>
 <li>Средства резервируются на эскроу-счете до подтверждения выполнения</li>
 <li>После подтверждения выполнения средства распределяются:</li>
 <li className="ml-4">• 10-25% зачисляются Администрации (комиссия)</li>
 <li className="ml-4">• 75-90% переводятся Исполнителю</li>
 </ul>
 <div className="mt-3 p-2 bg-yellow-50 rounded text-xs">
 <p><strong>Сроки:</strong>Распределение средств происходит в течение 3-7 рабочих дней после подтверждения выполнения задания клиентом. В настоящее время выплаты исполнителям производятся администрацией вручную на указанные банковские реквизиты или через СБП.</p>
 </div>
 </div>
 
 <div className="mt-4 bg-gray-100 p-4 rounded">
 <h4 className="font-semibold mb-2">3.2.4. Язык документов и технические ограничения:</h4>
 <div className="text-sm space-y-2">
 <p>
 <strong>1.</strong>Все налоговые уведомления, кассовые чеки и фискальные документы формируются на русском языке 
 в соответствии с требованиями ФНС РФ для самозанятых.
 </p>
 <p>
 <strong>2.</strong>Исполнители обязаны самостоятельно вести налоговую отчетность в соответствии с применяемым налоговым режимом. 
 Платформа не ведет налоговую отчетность за исполнителей.
 </p>
 <p>
 <strong>3.</strong>Распределение средств между Администрацией и Исполнителем происходит 
 в течение 3-7 рабочих дней после подтверждения выполнения задания. Выплаты исполнителям 
 производятся администрацией вручную на банковские карты или через СБП по указанным реквизитам.
 </p>
 <p>
 <strong>4.</strong>В случае технических сбоев платежной системы сроки могут быть увеличены до 5-7 рабочих дней. 
 Пользователи уведомляются о задержках через Сервис.
 </p>
 </div>
 
 {/* НОВЫЙ ПОДРАЗДЕЛ - Изменение стоимости */}
 <div className="mt-4 bg-purple-50 p-4 rounded">
 <h4 className="font-semibold text-purple-800 mb-2">3.2.5. Изменение стоимости и дополнительные платежи:</h4>
 <div className="text-sm space-y-2">
 <p>
 <strong>Порядок оплаты:</strong> При создании задания Заказчик производит полную оплату через сервис ЮKassa. 
 Средства поступают на счёт Администрации и резервируются до подтверждения выполнения задания. 
 Распределение между Исполнителем и Администрацией происходит после подтверждения Заказчиком результата.
 </p>
 <p>
 <strong>Процедура изменения цены:</strong> В период обсуждения задания стороны могут согласовать изменение стоимости через чат платформы. 
 При увеличении цены Заказчик производит доплату дополнительным платежом; при снижении цены — 
 Администрация инициирует возврат разницы на исходный способ оплаты Заказчика. 
 Все изменения фиксируются в истории задания.
 </p>
 <p>
 <strong>Возвраты:</strong> При отмене задания до начала выполнения средства возвращаются Заказчику за вычетом 
 комиссии платёжной системы (ЮKassa), которая не подлежит возврату согласно тарифам ЮKassa. 
 Возврат осуществляется в течение 3–7 рабочих дней на исходный способ оплаты.
 </p>
 </div>
 </div>
 </div>
 </div>

 {/* 4. Обязанности Исполнителя */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">4. Обязанности Исполнителя</h3>
 
 <div className="grid md:grid-cols-2 gap-4">
 <div className="space-y-4">
 <div className="bg-green-50 p-4 rounded">
 <h4 className="font-semibold text-green-800 mb-2">Перед началом работы:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Заполнить профиль с контактной информацией</li>
 <li>Подписать «Соглашение с Исполнителем»</li>
 <li>Настроить подключение к «Моему налогу»</li>
 </ul>
 </div>

 <div className="bg-blue-50 p-4 rounded">
 <h4 className="font-semibold text-blue-800 mb-2">После оплаты:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Вести учет доходов в соответствии с налоговым режимом</li>
 <li>Уведомить клиента о готовности материалов</li>
 <li>Не требовать дополнительных платежей</li>
 </ul>
 </div>
 </div>

 <div>
 <div className="bg-red-50 p-4 rounded">
 <h4 className="font-semibold text-red-800 mb-2">Запрещено:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Обсуждать с клиентом комиссию платформы</li>
 <li>Передавать заказы третьим лицам</li>
 <li>Использовать логотип «Реверсии» без согласования</li>
 <li>Раскрывать личность для услуг «Тайный покупатель»</li>
 </ul>
 </div>
 </div>
 </div>

 {/* Требования к спецуслугам */}
 <div className="mt-4 bg-purple-50 p-4 rounded">
 <h4 className="font-semibold text-purple-800 mb-3">Требования к специальным услугам:</h4>
 <div className="grid md:grid-cols-3 gap-4 text-sm">
 <div>
 <strong>«Тайный покупатель»:</strong>
 <ul className="list-disc list-inside mt-1">
 <li>Анонимность в переписке</li>
 <li>Использование шаблона отчета</li>
 </ul>
 </div>
 <div>
 <strong>«Уход за захоронениями»:</strong>
 <ul className="list-disc list-inside mt-1">
 <li>Фотоотчет с геометками</li>
 <li>Согласование чек-листа работ</li>
 </ul>
 </div>
 <div>
 <strong>«Мобильный корреспондент»:</strong>
 <ul className="list-disc list-inside mt-1">
 <li>Видео 4K, фото 12 МП</li>
 <li>Геометка в метаданных</li>
 <li>Запрет субподряда</li>
 </ul>
 </div>
 </div>
 </div>
 </div>

 {/* 5. Ответственность сторон */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">5. Ответственность сторон</h3>
 
 <div className="grid md:grid-cols-3 gap-4">
 <div className="bg-gray-50 p-4 rounded">
 <h4 className="font-semibold text-gray-800 mb-2">Администрация отвечает за:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Работу платформы (технические сбои)</li>
 <li>Корректность распределения платежей</li>
 <li>Конфиденциальность данных</li>
 </ul>
 </div>

 <div className="bg-yellow-50 p-4 rounded">
 <h4 className="font-semibold text-yellow-800 mb-2">Исполнитель отвечает за:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Качество и сроки съемки</li>
 <li>Налоговую отчетность в соответствии с применяемым режимом</li>
 <li>Соблюдение законов РФ при съемке</li>
 </ul>
 </div>

 <div className="bg-blue-50 p-4 rounded">
 <h4 className="font-semibold text-blue-800 mb-2">Клиент обязан:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Своевременно оплачивать заказы</li>
 <li>Предоставлять точные данные о месте/времени</li>
 <li>Не передавать логин/пароль третьим лицам</li>
 </ul>
 </div>
 </div>
 </div>

 {/* 6. Форс-мажорные обстоятельства */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">6. Форс-мажорные обстоятельства</h3>
 
 <div className="grid md:grid-cols-2 gap-4">
 <div className="bg-red-50 p-4 rounded">
 <h4 className="font-semibold text-red-800 mb-2">Для Администрации:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Хакерская атака на серверы</li>
 <li>Блокировка платежных систем</li>
 <li>Сбой банковской инфраструктуры</li>
 </ul>
 </div>

 <div className="bg-orange-50 p-4 rounded">
 <h4 className="font-semibold text-orange-800 mb-2">Для Исполнителя:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Поломка фотооборудования</li>
 <li>Болезнь (при медсправке)</li>
 <li>ЧП на локации съемки</li>
 </ul>
 </div>
 </div>

 <div className="mt-4 bg-gray-100 p-4 rounded">
 <h4 className="font-semibold mb-2">Общие правила:</h4>
 <ul className="list-disc list-inside text-sm space-y-1">
 <li>Уведомление через приложение в течение 2 часов</li>
 <li>Предоставление доказательств (фото/скрины/документы)</li>
 <li>Автоматическое продление сроков на период форс-мажора</li>
 </ul>
 </div>
 </div>

 {/* 7. Разрешение споров */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">7. Разрешение споров</h3>
 <div className="bg-blue-50 p-4 rounded">
 <p className="text-sm">Все споры подлежат рассмотрению в <strong>Арбитражном суде Краснодарского края</strong>по месту 
 регистрации Администрации.
 </p>
 <p className="text-sm mt-2">Потребители (физические лица) вправе обращаться в суд по своему месту жительства в соответствии 
 с Законом РФ «О защите прав потребителей».
 </p>
 </div>
 </div>

 {/* 8. Реквизиты администрации */}
 <div>
 <h3 className="text-xl font-semibold text-gray-800 mb-4">8. Реквизиты администрации</h3>
 <div className="bg-gray-50 p-4 rounded">
 <div className="grid md:grid-cols-2 gap-4">
 <div>
 <h4 className="font-semibold mb-2">Администрация платформы:</h4>
 <p><strong>ФИО:</strong>Сумченко О.А.</p>
 <p><strong>ИНН:</strong> 230808284051</p>
 </div>
 <div>
 <h4 className="font-semibold mb-2">Контактная информация:</h4>
 <p><strong>Email:</strong> 
 <a href="mailto:support@reversia.ru" className="text-blue-600 hover:underline ml-1">support@reversia.ru
 </a>
 </p>
 <p><strong>Режим работы:</strong>Пн-Пт: 9:00-18:00 (МСК)</p>
 <p><strong>Домен:</strong>https://reversia.ru</p>
 </div>
 </div>
 </div>
 </div>

{/* 9. Задания от организаций (B2B) */}
<div>
<h3 className="text-xl font-semibold text-gray-800 mb-4">9. Задания от организаций (B2B)</h3>
<div className="space-y-3 text-sm">
<div>
<strong>9.1.</strong> Заказчик, действующий от имени юридического лица или индивидуального предпринимателя, вправе разместить задание в формате «Задание от организации» (далее — B2B-задание), указав ИНН и наименование организации, а также адрес электронной почты для получения документов.
</div>
<div>
<strong>9.2.</strong> По B2B-заданиям Платформа не принимает, не резервирует и не перечисляет денежные средства. Расчёты за выполненное задание производятся Заказчиком напрямую Исполнителю по реквизитам, предоставленным Исполнителем. Условия о резервировании средств, возврате средств и выплатах через Платформу (разделы 2.8 и 3 настоящего Соглашения и Политика возвратов) к B2B-заданиям не применяются.
</div>
<div>
<strong>9.3.</strong> Откликаться на B2B-задания вправе только Исполнители, указавшие в профиле бизнес-статус (самозанятый, индивидуальный предприниматель или организация) и ИНН. Бизнес-статус указывается Исполнителем самостоятельно и Платформой не проверяется. Исполнитель несёт полную ответственность за достоверность указанного статуса, за соблюдение налогового законодательства и за выдачу Заказчику чека (в том числе в порядке Федерального закона от 27.11.2018 № 422-ФЗ).
</div>
<div>
<strong>9.4.</strong> Платформа предоставляет сторонам B2B-задания шаблоны договора-оферты и акта выполненных работ, сформированные по данным задания и профилей сторон. Указанные документы являются информационным сервисом Платформы, подлежат проверке и подписанию сторонами самостоятельно. Платформа не является стороной договора между Заказчиком и Исполнителем, не выступает агентом, поручителем или платёжным посредником и не несёт ответственности за исполнение сторонами обязательств по такому договору.
</div>
<div>
<strong>9.5.</strong> Указывая бизнес-статус и ИНН, Исполнитель даёт согласие на передачу своих ФИО и ИНН Заказчику B2B-задания в объёме, необходимом для оформления договора и акта (ст. 6, 9 Федерального закона от 27.07.2006 № 152-ФЗ). ИНН хранится на Платформе в зашифрованном виде и не публикуется.
</div>
<div>
<strong>9.6.</strong> Реквизиты организации-Заказчика (ИНН, наименование, адрес электронной почты для документов) не публикуются на общедоступных страницах Платформы и предоставляются только Исполнителю, принявшему задание, и администрации Платформы.
</div>
<div>
<strong>9.7.</strong> Комиссия Платформы по B2B-заданиям на текущем этапе не взимается. Платформа вправе ввести комиссию или платные сервисы для B2B-заданий, уведомив пользователей заранее в порядке, предусмотренном для изменения условий настоящего Соглашения.
</div>
</div>
</div>


 </div>
 </div>
 </div>
 );
};

